/**
 * # Routes declarations
 *
 * We declare routes here in order to document hierarchy and to have a full route string if needed.
 */
import * as PARAMS from './parameters';

export const ACTIVITY = `${PARAMS.ACTIVITY_ID}`;
export const PLAYBACK = `${ACTIVITY}/${PARAMS.PLAYBACK}`;
export const PLAYBACK_COMPARISON = `${PLAYBACK}/${PARAMS.PLAYBACK_COMPARISON}`;
export const VISUALIZER_3D = `${ACTIVITY}/${PARAMS.VISUALIZER_3D}`;
export const LAYOUT_EDITOR = `${ACTIVITY}/${PARAMS.LAYOUT}/${PARAMS.LAYOUT_ID}`;
export const STUDENT_SETTINGS = `/${PARAMS.STUDENT_SETTINGS}`;
export const USER_SETTINGS = `${ACTIVITY}/${PARAMS.USER_SETTINGS}`;
export const CLUBS = `${ACTIVITY}/${PARAMS.CLUBS}`;
export const TAGS = `${ACTIVITY}/${PARAMS.TAGS}`;
export const PARAMETERS = `${ACTIVITY}/${PARAMS.PARAMETERS}`;
export const OVERVIEW = `${ACTIVITY}/${PARAMS.OVERVIEW}`;
export const REPORT = `${ACTIVITY}/${PARAMS.REPORT}`;
export const GOAL_REPORT = `${ACTIVITY}/${PARAMS.GOAL_REPORT}/${PARAMS.LAYOUT_ID}`;
export const BOOTH_LOGIN = '/setup';
export const LOGIN = `/login`;
export const REGISTER = `/register`;
export const CONFIRM = `/confirm`;
export const RESET_PASSWORD = `/reset-password`;
export const CHANGE_PASSWORD = `/change-password`;
